export default __webpack_public_path__ + "static/media/warningOrg.a4639622.svg";